import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilSimple = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.5858 3.99985C20.3668 3.2188 21.6332 3.2188 22.4142 3.99985L28 9.58564C28.781 10.3667 28.781 11.633 28 12.4141L13 27.4141C12.8122 27.6019 12.5909 27.7485 12.3502 27.848L12.2329 27.8923C12.0202 27.9639 11.8048 27.9998 11.5858 27.9998H6C4.89543 27.9998 4 27.1044 4 25.9998V20.4141C4 20.1969 4.03532 19.9834 4.10279 19.7811L4.1554 19.6443C4.25384 19.4053 4.39955 19.1861 4.58579 18.9998L19.5858 3.99985ZM5.999 22.4131L6 25.9998L9.585 25.9991L5.999 22.4131ZM17 9.41406L6.414 19.9991L11.999 25.5851L22.585 14.9991L17 9.41406ZM21 5.41406L18.414 7.99906L24 13.5851L26.5858 10.9998L21 5.41406Z",
		fill: "#202227"
	})
});
export default SvgPencilSimple;
